<div class="giftshop-cart" [formGroup]="form">
	<div class="row column">
		<p class="giftshop-hint" [innerHTML]="'giftshop.cart.hint' | translate"></p>
	</div>
	<div class="row column">
		<p class="giftshop-teaser" [innerHTML]="'giftshop.cart.teaser' | translate" *ngIf="items.length > 0"></p>
		<p class="giftshop-teaser" [innerHTML]="'giftshop.cart.teaser.empty' | translate" *ngIf="items.length == 0"></p>
	</div>

	<div class="giftshop-cart-items">
		<div class="giftshop-cart-item" *ngFor="let item of items; index as i">
			<div class="row column">
				<h3>{{'giftshop.cart.item.headline' | translate: {'item': (i + 1)} }}</h3>
			</div>
			<div class="row">
				<div class="column small-12 medium-8">
					<div class="name">
						<img class="show-for-medium" *ngIf="item.product.images.length > 0" [src]="getProuctImage(item.product)" [alt]="item.product.name">
						<h4 [innerHTML]="item.product.name"></h4>
						<a (click)="removeItem(i)" (keydown.space)="removeItem(i)" tabindex="0" [title]="'shop.cart.item.remove' | translate"><i class="twingle-bin2"></i></a>
						<div class="flex-wrap"></div>
						<div class="giftshop-price">
							<a class="twingle-minus1" tabindex="0" (click)="decreaseCount(i, item.count)" (keydown.space)="decreaseCount(i, item.count)" *ngIf="item.freePrice === null" [title]="'giftshop.item.decrease' | translate"></a>
							<strong>{{((item.freePrice || item.product.price) * item.count) | number: '1.0-0'}} {{donation.currencySymbol}}</strong>
							<a class="twingle-plus1" tabindex="0" (click)="increaseCount(i, item.count)" (keydown.space)="increaseCount(i, item.count)" *ngIf="item.freePrice === null" [title]="'giftshop.item.increase' | translate"></a>
						</div>
					</div>

					<div class="row form">
						<textfield (onBlur)="updatePreviewUrl(i)" [maxLength]="40" [showLabel]="true" [(model)]="item.giftReceiver" [name]="'gift.receiver.' + i" [label]="'gift.config.receiver.name' | translate" [error]="'gift.config.receiver.error' | translate" [wrapperClass]="'column small-12'" [required]="true" [form]="form"></textfield>
						<textfield *ngIf="hideSender === false" (onBlur)="updatePreviewUrl(i)" [maxLength]="40" [showLabel]="true" [(model)]="item.giftSender" [name]="'gift.sender.' + i" [label]="'gift.config.sender' | translate" [error]="'gift.config.sender.error' | translate" [required]="true" [form]="form" [wrapperClass]="'column small-12'"></textfield>						<messagefield *ngIf="hideMessage === false" (onBlur)="updatePreviewUrl(i)" [showLabel]="true" [name]="'gift.message.' + i" [(model)]="item.giftMessage" [maxLength]="300" [label]="'gift.config.message' | translate" [error]="'gift.config.message.error' | translate" [required]="false" [rows]="5" [form]="form" [wrapperClass]="'column small-12'"></messagefield>
					</div>
				</div>
				<div class="column small-12 medium-4">
					<div class="preview-wrapper">
						<img *ngIf="imageLoad[i] && imageLoad[i].url" class="preview" [class.is-loading]="!imageLoad[i] || imageLoad[i].load !== false" [src]="imageLoad[i].url" alt="" (load)="imageLoad[i].load = false">
						<div class="image-loading" *ngIf="!imageLoad[i] || imageLoad[i].load !== false"></div>
					</div>
				</div>
				<div class="column small-12">
					<hr>
				</div>
			</div>
		</div>
	</div>

	<div class="row">
		<amount-extra [donation]="donation" [form]="form" [amount]="donation.amount"></amount-extra>
	</div>

	<div class="row button-wrapper">
		<div class="column small-12" [class.medium-6]="donation.amount > 0" [class.large-4]="donation.amount > 0">
			<button class="button secondary" (click)="addItem()"><i class="twingle-plus1"></i> {{'giftshop.cart.additem' | translate}}</button>
		</div>
		<div class="column small-12 medium-6 large-8" *ngIf="donation.amount > 0">
			<button  class="button arrow arrow-right" [class.grey]="!formValid" (click)="nextStep()">{{(contactMandatory? 'widget.start.button' : 'giftshop.cart.button') | translate: getSubmitButtonPlaceholders() }}</button>
		</div>
	</div>
</div>
